import React from 'react';
import { CreativeListModelProps } from './CreativeListModel';
import i18n from 'i18n';
import styles from './CreativeList.module.scss';
import classNames from 'classnames/bind';
import { LoadingIndicator } from 'components/LoadingIndicator';
import { Redirect } from 'react-router-dom';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import { addOnEnabled, hasFuncs } from 'core/permission/PermissionDSL';
import { Permission } from 'core/auth/Permission';
import { TablePlaceholder } from 'components/TablePlaceholder/TablePlaceholder';
import { StickableBootstrapTable } from 'components/Table/StickableBootstrapTable';
import { PermissionItem } from 'core';
import { ADDONFEATURE } from 'core/agency/AddonFeature';
import { Modal } from 'components/Modal/Modal';
import { CreativeRelatedProductList, CreativeRelatedProductListColumns } from 'containers/Creatives/CreativeList/CreativeRelatedProductList';

export class CreativeList extends React.Component<CreativeListModelProps> {
  handler: number;
  cssClassNames: any;
  campaignWritePermission: PermissionItem;

  constructor (props) {
    super(props);
    this.cssClassNames = classNames.bind(styles);
    this.handler = this.props.model.event.add((model) => {
      this.setState(model.state);
    });
    const l1Object = this.props.model.l1Object;
    const channelAddonFeature = l1Object ? ADDONFEATURE.CHANNEL[l1Object.channel] : undefined;
    this.campaignWritePermission = channelAddonFeature ?
      hasFuncs(Permission.CAMPAIGN_WRITE).and(addOnEnabled(channelAddonFeature)) :
      hasFuncs(Permission.CAMPAIGN_WRITE);
  }

  componentDidUpdate (prevProps) {
    if (prevProps.model !== this.props.model) {
      prevProps.model.event.remove(this.handler);
      this.handler = this.props.model.event.add((model) => {
        this.setState(model.state);
      });
      this.props.model.onPageChange(prevProps.model.page, prevProps.model.sizePerPage);
    }
  }

  componentWillUnmount () {
    this.props.model.event.remove(this.handler);
  }

  renderListNoDataIndication = () => {
    const renderSystemAdminPlaceholder = () => <TablePlaceholder placeholder={i18n.t<string>('campaignCreativeList.labels.noDataWithoutAddPermission')}/>;
    return (
      <PermissionChecker
        permissionAware={this.campaignWritePermission}
        renderOtherwise={renderSystemAdminPlaceholder}
      >
        <TablePlaceholder placeholder={i18n.t<string>('campaignCreativeList.labels.noData')}/>
      </PermissionChecker>
    );
  }

  renderCreativeRelatedProductListModal = () => {
    const { creativeToShowRelatedProducts } = this.props.model.state;
    if (!creativeToShowRelatedProducts || !creativeToShowRelatedProducts.relatedProductInfo) {
      return null;
    }

    const {
      hideCreativeRelatedProductListModal
    } = this.props.model;
    return (
      <Modal
        className={styles.creativeRelatedProductListModal}
        title={creativeToShowRelatedProducts.name}
        secondaryButton={{
          title: i18n.t<string>('common.buttons.close'),
          callback: hideCreativeRelatedProductListModal
        }}
        dismiss={hideCreativeRelatedProductListModal}
        animation={false}
      >
        <CreativeRelatedProductList
          creativeRelatedProductInfo={creativeToShowRelatedProducts.relatedProductInfo}
          reviewCreatives={this.props.model.reviewCreatives.bind(this.props.model)}
          ignoreColumns={[CreativeRelatedProductListColumns.UTIME]}
        />
      </Modal>
    );
  }

  render () {
    const model = this.props.model;
    const rowClasses = (creative) => {
      let classes: any = null;
      if (creative.stateColumn && creative.stateColumn.styleName === 'budgetRemain') {
        classes = [classes, styles.lightDanger].join(' ');
      }

      return classes;
    };

    if (model.state.redirectPath) {
      return <Redirect push to={model.state.redirectPath}/>;
    }
    return (
      <div className={styles.creativeList}>
        {model.state.loading && <LoadingIndicator />}
        {this.renderCreativeRelatedProductListModal()}
        <div className={styles.tableContainer}>
          <StickableBootstrapTable
            hover
            keyField='id'
            stickFirstColumn
            stickLastColumn
            data={model.creativeList}
            columns={model.columns}
            summaryData={model.summaryData}
            noDataIndication={this.renderListNoDataIndication}
            rowClasses={rowClasses}
            pagination={{
              page: model.state.page,
              sizePerPage: model.sizePerPage,
              onPageChange: model.onPageChange
            }}
          />
        </div>
      </div>
    );
  }
}
